import React from 'react';
import { connectStateResults } from 'react-instantsearch-dom';

const CollectionHits = connectStateResults(({ searchState, searchResults, isSearchStalled, children, allSearchResults }) => {
  const hasQuery = searchState && searchState.query;
  const hasResults = searchResults && searchResults.nbHits;
  const categoriesHeading = window.theme.strings.searchCategories || null;
  const nbHits = (allSearchResults && allSearchResults['shopify_Thermomix_AUproducts'] && allSearchResults['shopify_Thermomix_AUproducts'].nbHits) || 0;
  const query = (allSearchResults && allSearchResults['shopify_Thermomix_AUproducts'] && allSearchResults['shopify_Thermomix_AUproducts'].query) || '';

  if (!hasQuery || isSearchStalled || (hasQuery && !hasResults)) {
    return null;
  }

  return (
    <div className="search-modal__results-categories">
      {categoriesHeading !== null && <p className='heading'>{categoriesHeading}</p>}
      {children}
      {nbHits !== null && <a href={`/search?query=${query}`} className='wrap-total-results'><p className='total_product_results'>Show all results (<strong>{nbHits}</strong>) </p>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <g id="ChevronRight">
            <path id="Vector" d="M7.5 3.75L13.75 10L7.5 16.25" stroke="#4A4A4A" strokeLinecap="round" strokeLinejoin="round" />
          </g>
        </svg>
      </a>}
    </div>
  );
});

export default CollectionHits;